import {MoreHoriz} from '@mui/icons-material';
import {Avatar, Box, ListItemButton, ListItemIcon, ListItemText, useTheme} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppDropDownMenu, AppDropDownMenuOptions} from 'components/menus';
import {useGetAllWorkSpaces, useUpdateUserWorkspaceToBeSelected, useWorkSpaceRedux} from 'hooks';
import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {appRoutes} from 'routes';
import {sessionSelector} from 'store/auth/sessionSlice';
import {WorkspaceSetting} from 'views/settings';
import {DrawerContentWorkSpaceItemSkeleton} from '../app-drawers';
interface WorkSpaceDropDownMenuProps {
    isMiniDrawer: boolean;
}

export const WorkspaceDropDownMenu: React.FC<WorkSpaceDropDownMenuProps> = ({isMiniDrawer}) => {
    const navigate = useNavigate();
    const {workspaceId, tenantId} = useParams();
    const {updateUserWorkspaceToBeSelected} = useUpdateUserWorkspaceToBeSelected();
    const {setSelectedWorkSpaceInRedux, selectedWorkSpace} = useWorkSpaceRedux();
    const theme = useTheme();
    const [searchFieldValue, setSearchFieldValue] = useState<string>('');
    const {getAllWorkSpaces, getAllWorkSpacesLoading, getAllWorkSpacesResponse} = useGetAllWorkSpaces();
    const {tenantSlug, workspaceSlug} = useSelector(sessionSelector);
    const location = useLocation();
    useEffect(() => {
        if (tenantId || location.pathname.includes('my-work')) {
            console.log('tenantId', tenantId);

            getAllWorkSpaces();
        }
    }, [tenantId]);

    useEffect(() => {
        if (!getAllWorkSpacesLoading && getAllWorkSpacesResponse.length) {
            const workspaceValue = workspaceId ?? selectedWorkSpace?.slug ?? workspaceSlug;
            const selectedOne = getAllWorkSpacesResponse.find(workspace => workspace.slug === workspaceValue);

            if (selectedOne) {
                setSelectedWorkSpaceInRedux(selectedOne);
            } else {
                const selectSessionWorkspace = getAllWorkSpacesResponse.find(
                    workspace => workspace.slug === workspaceSlug,
                );
                setSelectedWorkSpaceInRedux(selectSessionWorkspace ?? getAllWorkSpacesResponse[0]);
            }
        }
    }, [getAllWorkSpacesResponse, getAllWorkSpacesLoading, workspaceId]);

    const handleSelectWorkspace = (input: AppDropDownMenuOptions) => {
        const selectedWorkSpace = getAllWorkSpacesResponse.find(workspace => workspace.id === input.value);
        if (!selectedWorkSpace) {
            return;
        }
        setSelectedWorkSpaceInRedux(selectedWorkSpace);
        if (selectedWorkSpace) {
            updateUserWorkspaceToBeSelected({
                variables: {
                    workspaceId: selectedWorkSpace.id,
                },
            });
        }
        navigate(
            appRoutes.workspace.boardListing(
                !location.pathname.includes('my-work') ? tenantId : tenantSlug,
                selectedWorkSpace.slug,
                selectedWorkSpace.selectedBoardSlug,
            ),
        );
    };

    const workspaceValues = useMemo((): AppDropDownMenuOptions[] => {
        return getAllWorkSpacesResponse.map(x => ({label: x.title, value: x.id}) as AppDropDownMenuOptions);
    }, [getAllWorkSpacesResponse, searchFieldValue]);
    console.log('getAllWorkSpacesLoading', getAllWorkSpacesLoading);

    if (getAllWorkSpacesLoading) {
        return <DrawerContentWorkSpaceItemSkeleton />;
    }
    return (
        <>
            <AppDropDownMenu
                handleOptionSelect={handleSelectWorkspace}
                title="Workspaces"
                showSearchField={false}
                renderOptions={value => (
                    <>
                        <WorkspaceSetting />
                        {value}
                    </>
                )}
                // menuHeaderComponent={}
                sx={{
                    marginTop: -2,
                    marginLeft: -2,
                }}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                options={workspaceValues}
                searchFieldTitle="Search"
                searchFieldProps={{
                    value: searchFieldValue,
                    onChange: e => setSearchFieldValue(e.target.value),
                }}
                renderElement={(handleOpen, open) => (
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <ListItemButton
                            style={{paddingRight: '15px', paddingLeft: !isMiniDrawer ? '0px' : undefined}}
                            onClick={e => {
                                handleOpen(e);
                            }}
                        >
                            <ListItemIcon style={{paddingLeft: isMiniDrawer ? '0px' : '15px'}}>
                                <Avatar
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        background: theme.palette.primary.main,
                                    }}
                                >
                                    {selectedWorkSpace?.title.charAt(0)}
                                </Avatar>
                            </ListItemIcon>
                            {isMiniDrawer && <ListItemText>{selectedWorkSpace?.title}</ListItemText>}
                            {isMiniDrawer && (
                                <AppIconButton onClick={e => handleOpen(e)} size="small">
                                    <MoreHoriz />
                                </AppIconButton>
                            )}
                        </ListItemButton>
                    </Box>
                )}
            />
        </>
    );
};

export default WorkspaceDropDownMenu;
